import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import ArrowUp from 'src/assets/images/vectors/arrow-up.svg'
import ArrowDown from 'src/assets/images/vectors/arrow-down.svg'

export const FaqSection = (props) => {
  const { t } = useTranslation()

  return (
    <FaqSectionContainer>
        <h1>FAQ</h1>
        <StyledAccordion
            title={t('landingPage.faqSection.faq1.question')}
            content={t('landingPage.faqSection.faq1.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq2.question')}
            content={t('landingPage.faqSection.faq2.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq3.question')}
            content={t('landingPage.faqSection.faq3.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq4.question')}
            content={t('landingPage.faqSection.faq4.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq5.question')}
            content={t('landingPage.faqSection.faq5.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq6.question')}
            content={t('landingPage.faqSection.faq6.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq7.question')}
            content={t('landingPage.faqSection.faq7.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq8.question')}
            content={t('landingPage.faqSection.faq8.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq9.question')}
            content={t('landingPage.faqSection.faq9.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq10.question')}
            content={t('landingPage.faqSection.faq10.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq11.question')}
            content={t('landingPage.faqSection.faq11.answer')}
        />
        <StyledAccordion
            title={t('landingPage.faqSection.faq12.question')}
            content={t('landingPage.faqSection.faq12.answer')}
        />
    </FaqSectionContainer>
  )
}

export default FaqSection

const Accordion = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div tabIndex={0} role='button' className={`accordion ${props.className || ''}`} onClick={() => setIsOpen(!isOpen)}>
            <div className='accordion-top'>
                <div className='accordion-top__title'>{props.title}</div>
                <div className='accordion-top__arrow'>
                    { isOpen ? <img src={ArrowUp} alt='arrow-up' /> : <img src={ArrowDown} alt='down' />}
                </div>
            </div>
            {isOpen && <div className='accordion__content'>{props.content}</div>}
        </div>
    )
}

const StyledAccordion = styled(Accordion)`
    padding-top: 20px;

    .accordion-top {
        display: flex;
        align-items: center;
        border-bottom: 1px solid ${props => props.theme.palette.common.gray200};
        padding-bottom: 20px;
        cursor: pointer;

        .accordion-top__title {
            font-size: 18px;
            font-weight: 700;
            line-height: 1.5;
            max-width: 95%;
        }

        .accordion-top__arrow {
            margin-left: auto;
        }
    }

    .accordion__content {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5;
    }
`

const FaqSectionContainer = styled.div`
    margin-top: 128px;
    padding: 0 20px;
    color: ${props => props.theme.palette.common.black};

    ${props => props.theme.breakpointsMedia.desktop} {
        width: 844px;
        margin: 96px auto;
    }

    h1 {
        font-size: 30px;
        font-weight: 700;
        text-align: center;
        padding-bottom: 32px;

        ${props => props.theme.breakpointsMedia.desktop} {
            font-size: 36px;
            font-weight: 800;
            padding-bottom: 28px;
        }
    }
`
